import {callApi} from '@/shared/ApiHelper'
import {checkForSignIn} from '@/shared/susiHelper'
import {useApiStore} from "@/store/api.js"

// Pinia store resolved lazily so this module is safe to static-import before
// app.use(pinia) runs. The Proxy preserves every `apiStore.x` call site
// (events-app#913).
function lazyStore(useStoreFn) {
    let resolved
    return new Proxy({}, {
        get(_, key) {
            if (!resolved) resolved = useStoreFn()
            return resolved[key]
        },
        set(_, key, value) {
            if (!resolved) resolved = useStoreFn()
            resolved[key] = value
            return true
        },
    })
}
const apiStore = lazyStore(useApiStore)

export const getTimeslotsByEvent = async function(eventId) {
    let apiResponse = await callApi(apiStore.buildUrl('/events/timeslots/?event=' + eventId))
    const timeslots = apiResponse.data
    return timeslots
}

export const getSessionsWithRegistrations = async function(eventId = 0, registeredOnly = false) {
    let oid = null
    if (registeredOnly) {
        oid = await checkForSignIn()
        if (oid) {
            apiStore.oid = oid
            try {
                let sessions = await sessionsByAttendee(oid, eventId)
                sessions = sessions.map((session) => {session.attending = true; return session})
                const markedSessions = await markMandatorySessions(oid, sessions, eventId)
                return markedSessions
            }
            catch (exception) {
                console.error(exception)
            }
        }
        return []
    }

    let sessionsWithRegistration = []
    try {
        let eventIdQueryString = 0 === eventId
            ? ''
            : '?event=' + eventId
        let apiResponse = await callApi(apiStore.buildUrl('/events/sessions/' + eventIdQueryString))
        const sessions = apiResponse.data
        if (Array.isArray(sessions)) {
            sessionsWithRegistration = sessions.map(
                (session) => {
                    session.attending = false
                    session.mandatory = false

                    return session
                }
            )
        }

        oid = await checkForSignIn()
        if (oid) {
            apiStore.oid = oid
            const registeredSessions = await sessionsByAttendee(oid, eventId)

            if (0 < registeredSessions.length) {
                sessionsWithRegistration = sessions.map(
                    (session) => {
                        if (registeredSessions.some( (r) => r.id === session.id)){
                            session.attending = true
                        }

                        return session
                    }
                )

                sessionsWithRegistration = await markMandatorySessions(oid, sessionsWithRegistration, eventId)
            }
        }
    } catch (exception) {
        console.error(exception)
    }

    return sessionsWithRegistration
}

export const markMandatorySessions = async function(oid, sessions, eventId = 0) {
    for (let i = 0; i < sessions.length; ++i) {
        sessions[i].mandatory = sessions[i].required
    }

    let idQueryString = '?mandatory=true&a=' + oid
    if (0 != eventId) {
        idQueryString += '&event=' + eventId
    }
        
    const apiResponse = await callApi(apiStore.buildUrl('/events/sessions/' + idQueryString))
    let mandatorySessions = []
    if (apiResponse && apiResponse.data) {
        mandatorySessions = apiResponse.data
    }

    return sessions.map(
        (session) => {
            if (mandatorySessions.some( (m) => m.id === session.id)) {
                session.mandatory = true
            }

            return session
        }
    )
}

export const sessionsByAttendee = async function(oid, eventId = 0) {
    let idQueryString = '?attendee=true&a=' + oid
    if (0 != eventId) {
        idQueryString += '&event=' + eventId
    }
    const apiResponse = await callApi(apiStore.buildUrl('/events/sessions/' + idQueryString))

    return apiResponse.data
}
